"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var calcPossibleSurveyorUsers_exports = {};
__export(calcPossibleSurveyorUsers_exports, {
  calcPossibleSurveyorUsers: () => calcPossibleSurveyorUsers
});
module.exports = __toCommonJS(calcPossibleSurveyorUsers_exports);
var import_types = require("@cartographerio/types");
var import_lodash = require("lodash");
function calcPossibleSurveyorUsers(props) {
  const { project, workspaceGraph } = props;
  return (0, import_lodash.sortBy)(
    (0, import_lodash.uniqBy)(
      [
        // Workspace admins:
        ...workspaceGraph.findUsersByWorkspaceId(project.workspaceId, import_types.WorkspaceRoleNameEnum.Admin),
        // Project surveyors:
        ...workspaceGraph.findUsersByProjectId(project.id, import_types.ProjectRoleNameEnum.Surveyor),
        // Related team surveyors:
        ...project.teamIds.flatMap((id) => workspaceGraph.findUsersByTeamId(id, import_types.TeamRoleNameEnum.Surveyor))
      ],
      ({ id }) => id
    ),
    ({ screenName }) => screenName
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  calcPossibleSurveyorUsers
});
//# sourceMappingURL=calcPossibleSurveyorUsers.js.map
